import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface loginPayloadDetails {
  accessToken: string;
  createdAt: string;
  createdBy: string | null;
  email: string;
  firstName: string;
  id: string;
  isActive: boolean;
  lastName: string;
  roleId: string;
  updatedAt: string;
}

interface AuthState {
  token_details: loginPayloadDetails | null;
  snackbarDetails: { type: string; message: string };
}

let initialState: AuthState = {
  token_details: null,
  snackbarDetails: { type: "", message: "" },
};

const AuthSliceReducer = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    setAuthToken(state, action: PayloadAction<loginPayloadDetails>) {
      state.token_details = action.payload;
    },
    clearAuthToken(state) {
      state.token_details = null;
    },
    setSnackbarDetails(state, action) {
      state.snackbarDetails = action.payload;
    },
  },
});

export const { setAuthToken, clearAuthToken, setSnackbarDetails } =
  AuthSliceReducer.actions;

export default AuthSliceReducer.reducer;
